/**添加文献弹框 */
<template>
  <el-dialog
    v-model="dialogVisible"
    :title="dialogTitle"
    append-to-body
    width="65%"
    :before-close="closeDLG"
  >
    <div class="container">
      <div class="input-box">
        <el-input
          placeholder="搜索文献"
          v-model="searchForm.keyword"
          @keyup.enter="getLiteratureList"
        >
          <template #prepend>
            <el-popover
              popper-class="theme-tree-popover"
              placement="bottom-start"
              width="auto"
              trigger="hover"
            >
              <div class="theme-tree">
                <el-tree
                  ref="treeRef"
                  :props="literatureCatalog.treeProps"
                  :data="literatureCatalog.treeData"
                  show-checkbox
                  node-key="uid"
                  accordion
                  check-strictly
                  @check="handleCheckChange"
                  :expand-on-click-node="false"
                  :default-checked-keys="[1]"
                >
                  <template #default="{ data }">
                    <span class="custom-tree-node">
                      <span>{{ data.title }}</span>
                    </span>
                  </template>
                </el-tree>
              </div>
              <template #reference>
                <el-button>
                  {{ selectedTopic.title }}
                  <i class="iconfont icon-xiala"></i>
                </el-button>
              </template>
            </el-popover>
          </template>
          <template #suffix>
            <el-icon class="el-input__icon"><search /></el-icon>
          </template>
        </el-input>
      </div>
      <!-- table -->
      <div class="table-box">
        <el-table
          ref="tableRef"
          :data="literatureList"
          style="width: 100%"
          height="100%"
          v-loading="tableLoading"
          @selection-change="handleSelectionChange"
          @sort-change="handleSortChange"
        >
          <el-table-column type="selection" width="40" />
          <el-table-column label="标题" prop="title" min-width="180">
            <template #default="scope">
              <span class="title">
                <el-tooltip
                  content="正在解析中..."
                  placement="top"
                  effect="dark"
                >
                  <el-tag
                    class="ai-tag-pending extract"
                    v-show="
                      scope.row.pdfExtractionStatus == AI_EXTRACT_STATUS.PENDING
                    "
                    disable-transitions
                  >
                    <div class="pending"></div>
                  </el-tag>
                </el-tooltip>
                <el-tag
                  class="ai-tag"
                  v-show="
                    scope.row.aiReadingStatus == AI_READING_STATUS.SUCCESS
                  "
                  disable-transitions
                >
                  AI
                </el-tag>
                <el-tag
                  class="ai-tag-pending"
                  v-show="
                    scope.row.aiReadingStatus == AI_READING_STATUS.PENDING
                  "
                  disable-transitions
                >
                  <span class="ai-text">AI</span>
                  <div class="pending"></div>
                </el-tag>
                <span
                  :style="
                    scope.row.pdfExtractionStatus == AI_EXTRACT_STATUS.FAIL
                      ? 'color:#DB1300'
                      : ''
                  "
                >
                  {{ scope.row.title }}
                </span>
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="authors"
            label="作者"
            max-width="160"
            show-overflow-tooltip
          >
            <template #default="scope">
              <span>
                {{ scope.row.authors || "-" }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="publicationYear"
            label="出版年份"
            width="120"
            sortable
          >
            <template #default="scope">
              <span>
                {{ scope.row.publicationYear || "-" }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="source" label="文献来源" max-width="150">
            <template #default="scope">
              <span>
                {{ scope.row.source || "-" }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="importanceLevel"
            label="重要度"
            width="150"
            sortable
          >
            <template #default="scope">
              <ImportanceStatus
                v-model:value="scope.row.importanceLevel"
                :disabled="true"
              ></ImportanceStatus>
            </template>
          </el-table-column>
          <el-table-column prop="file" label="文件" width="60">
            <template #default="scope">
              <div class="file-icon" v-show="scope.row.isUploadPdf">
                <img src="@/assets/imgs/upload/file_pdf.svg" alt="file" />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="uploadTime" label="上传日期" width="120" />
          <template #empty>
            <el-empty
              v-show="!tableLoading"
              :image-size="180"
              :image="require('@/assets/imgs/literature/empty.png')"
            >
              <template #description>暂无文献</template>
            </el-empty>
          </template>
        </el-table>
      </div>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <div class="pagination-box" v-if="!tableLoading">
          <el-pagination
            v-model:current-page="paginationState.pageNum"
            v-model:page-size="paginationState.pageSize"
            small
            layout="total, prev, pager, next, sizes"
            :total="paginationState.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 30, 40]"
          />
        </div>
        <el-button @click="closeDLG">取消</el-button>
        <el-button
          type="primary"
          @click="handleClickConfirm"
          :disabled="idSelectList.length == 0"
        >
          确认
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import {
  ref,
  reactive,
  defineEmits,
  defineExpose,
  computed,
  watch,
  defineProps,
} from "vue";
import { httpPost } from "@/api/httpService.js";
import { PAGE_TYPE, PAGE_TYPE_MAP } from "@/constant/page_type.js";
import { AI_READING_STATUS } from "@/constant/ai_reading_status.js";
import ImportanceStatus from "@/components/base/ImportanceStatus.vue";
import { AI_EXTRACT_STATUS } from "@/constant/ai_extract_status.js";

const emits = defineEmits(["select"]);

const uid = ref("");
const uidType = ref("");
const literatureList = ref([]);
//#region 弹框相关
const dialogVisible = ref(false);
const dialogTitle = ref("选择文献");
const dialogType = ref("CHOOSE");
const ADD_LITERATURE_TYPE = {
  REVIEW: 1,
  COMPARE: 2,
};
const openDLG = async (type, params) => {
  dialogVisible.value = true;
  dialogType.value = type;
  if (type == "ADD") {
    dialogTitle.value = "添加文献";
    uid.value = params.uid;
    uidType.value =
      params.type == "REVIEW"
        ? ADD_LITERATURE_TYPE.REVIEW
        : ADD_LITERATURE_TYPE.COMPARE;
  } else {
    dialogTitle.value = "选择文献";
  }
  await getSharedTheme();
  await getMyTheme();
  await getLiteratureList();
};
const closeDLG = () => {
  dialogVisible.value = false;
  literatureCatalog.treeData = [
    {
      uid: 1,
      title: "全部",
    },
    {
      uid: 2,
      title: "最近添加",
    },
    {
      uid: 3,
      title: "未分类",
    },
    {
      uid: 5,
      title: "无文件",
    },
  ];
  searchForm.value.keyword = "";
  searchForm.value.searchType = 0;
  searchForm.value.topicUid = "";
  searchForm.value.topicType = "";
  selectedTopic.value.title = PAGE_TYPE_MAP.ALL;
  selectedTopic.value.uid = 1;
  clearSelection();
};
//#endregion 弹框相关

//#region 头部筛选相关
const searchForm = ref({
  keyword: "",
  searchType: 0,
  topicUid: "",
  topicType: "",
});
const selectedTopic = ref({ title: PAGE_TYPE_MAP.ALL, uid: 1 });
//获取文献目录
const literatureCatalog = reactive({
  treeData: [
    {
      uid: 1,
      title: "全部",
    },
    {
      uid: 2,
      title: "最近添加",
    },
    {
      uid: 3,
      title: "未分类",
    },
    {
      uid: 5,
      title: "无文件",
    },
  ],
  treeProps: {
    label: "title",
    children: "children",
  },
});
//获取我的主题
const getMyTheme = async () => {
  let res = await httpPost("/literatureTopic/v1/searchTopicStructure");
  if (res.code == 0) {
    let structure = res.data.structure;
    structure.forEach((item) => {
      item.children.push({ uid: item.uid, title: "无子主题" });
    });
    literatureCatalog.treeData.push({
      uid: 4,
      title: "我的主题",
      disabled: true,
      children: structure,
    });
  }
};
//获取共享主题
const getSharedTheme = async () => {
  let res = await httpPost("/literatureTopic/v1/searchShareTopicStructure");
  if (res.code == 0) {
    let structure = res.data.structure;
    structure.forEach((item) => {
      item.children.push({ uid: item.uid, title: "无子主题" });
    });
    literatureCatalog.treeData.push({
      uid: 6,
      title: "共享主题",
      disabled: true,
      children: structure,
    });
  }
};
//改变复选框
const treeRef = ref({});
const handleCheckChange = (checkedNode) => {
  //获取选择的数据
  const currentNodeSelectedList = treeRef.value.getCheckedNodes();
  //一次只能选一个
  currentNodeSelectedList.forEach((node) => {
    if (node !== checkedNode) {
      treeRef.value.setChecked(node, false);
    }
  });
  selectedTopic.value.title = checkedNode.title;
  selectedTopic.value.uid = checkedNode.uid;
  switch (selectedTopic.value.title) {
    case PAGE_TYPE_MAP.ALL:
      searchForm.value.searchType = PAGE_TYPE.ALL;
      searchForm.value.topicType = "";
      searchForm.value.topicUid = "";
      break;
    case PAGE_TYPE_MAP.RECENT:
      searchForm.value.searchType = PAGE_TYPE.RECENT;
      searchForm.value.topicType = "";
      searchForm.value.topicUid = "";
      break;
    case PAGE_TYPE_MAP.UNCLASSIFIED:
      searchForm.value.searchType = PAGE_TYPE.UNCLASSIFIED;
      searchForm.value.topicType = "";
      searchForm.value.topicUid = "";
      break;
    case PAGE_TYPE_MAP.NO_FILES:
      searchForm.value.searchType = PAGE_TYPE.NO_FILES;
      searchForm.value.topicType = "";
      searchForm.value.topicUid = "";
      break;
    default:
      if (checkedNode.permission) {
        searchForm.value.searchType = PAGE_TYPE.SHARED_THEME;
      } else {
        searchForm.value.searchType = PAGE_TYPE.MY_THEME;
      }
      searchForm.value.topicUid = selectedTopic.value.uid;
      searchForm.value.topicType = checkedNode.children ? 1 : 2; //1：主题，2：子主题
      if (checkedNode.title == "无子主题") {
        searchForm.value.topicType = -1;
      }
      break;
  }
  getLiteratureList();
};
//#endregion 头部筛选相关

const tableLoading = ref(false);
//获取文献列表
const getLiteratureList = async () => {
  tableLoading.value = true;
  let params;
  let res;
  if (dialogType.value == "ADD") {
    params = {
      passUidType: uidType.value,
      pageNum: paginationState.pageNum,
      pageSize: paginationState.pageSize,
      reviewOrComparisonUid: uid.value,
      keyword: searchForm.value.keyword,
      topicUid: searchForm.value.topicUid,
      topicType: searchForm.value.topicType,
      searchType: searchForm.value.searchType,
      sortType: sortTemp.value.sortType,
      sort: sortTemp.value.sort,
    };
    res = await httpPost("/literature/v1/searchLiteratureByCpOrRv", params);
  } else {
    params = {
      pageNum: paginationState.pageNum,
      pageSize: paginationState.pageSize,
      conditionList: null,
      keyword: searchForm.value.keyword,
      keywords: null,
      topicUid: searchForm.value.topicUid,
      topicType: searchForm.value.topicType,
      searchType: searchForm.value.searchType,
      sortType: sortTemp.value.sortType,
      sort: sortTemp.value.sort,
    };
    res = await httpPost("/literature/v1/searchLiteratureByConditions", params);
  }
  if (res.code == 0) {
    literatureList.value = res.data.records;
    paginationState.total = res.data.total;
  }
  tableLoading.value = false;
};
// 排序
const sortTemp = ref({
  sortType: "",
  sort: "",
});
const SORT_TYPE = {
  publicationYear: 1,
  importanceLevel: 2,
};
const SORT_ORDER = {
  descending: 1,
  ascending: 2,
};
const handleSortChange = (obj) => {
  sortTemp.value.sortType = SORT_TYPE[obj.prop];
  sortTemp.value.sort = SORT_ORDER[obj.order];
  getLiteratureList();
};

//#region 分页信息
const paginationState = reactive({
  pageNum: 1,
  pageSize: 10,
  total: 0,
});
// 改变页面容纳数据量
const handleSizeChange = (val) => {
  paginationState.pageSize = val;
  getLiteratureList();
};
// 切换当前页码
const handleCurrentChange = (val) => {
  paginationState.pageNum = val;
  getLiteratureList();
};
//#endregion 分页信息

// 多选操作
const idSelectList = ref([]);
const handleSelectionChange = (val) => {
  idSelectList.value = val.map((item) => {
    return item.literatureUid;
  });
};
const tableRef = ref(null);
const clearSelection = () => {
  tableRef.value.clearSelection();
};
//确认
const handleClickConfirm = () => {
  emits("select", idSelectList.value);
};

/**暴露属性及方法 */
defineExpose({
  openDLG,
  closeDLG,
});
</script>

<style lang="scss" scoped>
@import "@/assets/styles/module/loading-animation.scss";
:deep(.el-input-group__prepend) {
  .el-button {
    background-color: #fff;
    border: 1px solid #dcdfe6;
    border-radius: 4px 0 0 4px;
    border-right: none;
  }
  .el-button:hover {
    background-color: #fff;
    border: 1px solid #dcdfe6;
    border-radius: 4px 0 0 4px;
    border-right: none;
  }
  .iconfont {
    margin-left: 5px;
  }
}
.theme-tree {
  width: 150px;
  max-height: 250px;
  overflow-y: auto;
}
:deep(.el-tree-node > .el-tree-node__content) {
  font-size: 13px;
  white-space: pre-wrap;
  word-break: break-all;
  height: auto;
  display: flex;
  align-items: flex-start;
  padding-bottom: 3px;
  border-radius: 5px;
  .custom-tree-node {
    position: relative;
    top: 4px;
  }
}
:deep(.el-tree-node > .el-tree-node__content):hover {
  background-color: #f5f5f5;
}
.container {
  height: 450px;
  padding: 15px 15px 0 15px;
  .input-box {
    width: 40%;
    text-align: left;
    margin-bottom: 10px;
  }
  .table-box {
    height: calc(100% - 35px);
    overflow: auto;
    :deep(.el-table__body) {
      .el-table__cell {
        font-size: 13px;
        padding: 10px 0;
      }
    }
    :deep(.el-table__header) {
      .el-table__cell {
        font-size: 14px;
      }
    }
    .title {
      text-align: justify;
      .ai-tag {
        width: 16px;
        height: 16px;
        font-size: 12px;
        background-color: #f6ece2;
        border-color: #f6ece2;
        color: #e8872c;
        margin-right: 5px;
      }
    }
    .file-icon {
      display: flex;
      align-items: center;
      width: 20px;
      img {
        width: 20px;
      }
    }
  }
}
.dialog-footer {
  .pagination-box {
    float: left;
    margin-left: 20px;
    position: relative;
    top: 5px;
  }
}

.ai-tag-pending {
  width: 16px;
  height: 16px;
  background-color: #efefef;
  border-color: #efefef;
  margin-right: 5px;
  .ai-text {
    color: #cbcbcb;
  }
}
.extract {
  width: 16px;
  height: 16px;
  background-color: #ffffff;
  border-color: #ffffff;
  margin-right: 5px;
  .ai-text {
    color: #cbcbcb;
  }
}
:deep(.el-tag) {
  border: none;
  padding: 0px;
}
</style>
